import type { DataLayerEvent } from '../model';

export function dataLayerPush(event: DataLayerEvent) {
    if (!window.dataLayer) {
        window.dataLayer = [];
    }
    window.dataLayer.push(event);
}
